import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { GlobalErrorHandler } from './errors/global-error-handler';
import { AuthInterceptor } from './interceptors/auth.interceptor';

@NgModule({
	imports: [
		CommonModule, //
		HttpClientModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		NzModalModule,
	],
	providers: [
		{
			// processes all errors
			provide: ErrorHandler,
			useClass: GlobalErrorHandler,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
	],
})
export class CoreModule {}
